

export const countriesWithIsoCode = [
    { value: "AF", label: "افغانستان" },
    { value: "AX", label: "Åland" },
    { value: "AL", label: "Shqipëri" },
    { value: "DZ", label: "الجزائر" },
    { value: "AS", label: "American Samoa" },
    { value: "AD", label: "Andorra" },
    { value: "AO", label: "Angola" },
    { value: "AI", label: "Anguilla" },
    { value: "AQ", label: "Antarctica" },
    { value: "AG", label: "Antigua and Barbuda" },
    { value: "AR", label: "Argentina" },
    { value: "AM", label: "Հայաստան" },
    { value: "AW", label: "Aruba" },
    { value: "AU", label: "Australia" },
    { value: "AT", label: "Österreich" },
    { value: "AZ", label: "Azərbaycan" },
    { value: "BS", label: "The Bahamas" },
    { value: "BH", label: "البحرين" },
    { value: "BD", label: "Bangladesh" },
    { value: "BB", label: "Barbados" },
    { value: "BY", label: "Беларусь" },
    { value: "BE", label: "België" },
    { value: "BZ", label: "Belize" },
    { value: "BJ", label: "Bénin" },
    { value: "BM", label: "Bermuda" },
    { value: "BT", label: "འབྲུག་ཡུལ་" },
    { value: "BO", label: "Bolivia (Plurinational State of)" },
    { value: "BQ", label: "Caribbean Netherlands" },
    { value: "BA", label: "Bosna i Hercegovina" },
    { value: "BW", label: "Botswana" },
    { value: "BV", label: "Bouvetøya" },
    { value: "BR", label: "Brasil" },
    { value: "IO", label: "British Indian Ocean Territory" },
    { value: "BN", label: "Brunei Darussalam" },
    { value: "BG", label: "България" },
    { value: "BF", label: "Burkina Faso" },
    { value: "BI", label: "Burundi" },
    { value: "CV", label: "Cabo Verde" },
    { value: "KH", label: "កម្ពុជា" },
    { value: "CM", label: "Cameroon" },
    { value: "CA", label: "Canada" },
    { value: "KY", label: "Cayman Islands" },
    { value: "CF", label: "République centrafricaine" },
    { value: "TD", label: "Tchad" },
    { value: "CL", label: "Chile" },
    { value: "CN", label: "中国" },
    { value: "CX", label: "Christmas Island" },
    { value: "CC", label: "Cocos (Keeling) Islands" },
    { value: "CO", label: "Colombia" },
    { value: "KM", label: "Komoros" },
    { value: "CG", label: "Congo" },
    { value: "CD", label: "République démocratique du Congo" },
    { value: "CK", label: "Cook Islands" },
    { value: "CR", label: "Costa Rica" },
    { value: "CI", label: "Côte d'Ivoire" },
    { value: "HR", label: "Hrvatska" },
    { value: "CU", label: "Cuba" },
    { value: "CW", label: "Curaçao" },
    { value: "CY", label: "Κύπρος" },
    { value: "CZ", label: "Česká republika" },
    { value: "DK", label: "Danmark" },
    { value: "DJ", label: "Djibouti" },
    { value: "DM", label: "Dominica" },
    { value: "DO", label: "República Dominicana" },
    { value: "EC", label: "Ecuador" },
    { value: "EG", label: "مصر" },
    { value: "SV", label: "El Salvador" },
    { value: "GQ", label: "Guinea Ecuatorial" },
    { value: "ER", label: "ኤርትራ" },
    { value: "EE", label: "Eesti" },
    { value: "SZ", label: "Eswatini" },
    { value: "ET", label: "ኢትዮጵያ" },
    { value: "FK", label: "Falkland Islands (Malvinas)" },
    { value: "FO", label: "Føroyar" },
    { value: "FJ", label: "Fiji" },
    { value: "FI", label: "Suomi" },
    { value: "FR", label: "France" },
    { value: "GF", label: "Guyane française" },
    { value: "PF", label: "Polynésie française" },
    { value: "TF", label: "Terres australes françaises" },
    { value: "GA", label: "Gabon" },
    { value: "GM", label: "Gambia" },
    { value: "GE", label: "საქართველო" },
    { value: "DE", label: "Deutschland" },
    { value: "GH", label: "Ghana" },
    { value: "GI", label: "Gibraltar" },
    { value: "GR", label: "Ελλάδα" },
    { value: "GL", label: "Kalaallit Nunaat" },
    { value: "GD", label: "Grenada" },
    { value: "GP", label: "Guadeloupe" },
    { value: "GU", label: "Guam" },
    { value: "GT", label: "Guatemala" },
    { value: "GG", label: "Guernsey" },
    { value: "GN", label: "Guinée" },
    { value: "GW", label: "Guiné-Bissau" },
    { value: "GY", label: "Guyana" },
    { value: "HT", label: "Haïti" },
    { value: "HM", label: "Heard Island and McDonald Islands" },
    { value: "VA", label: "Vatican City" },
    { value: "HN", label: "Honduras" },
    { value: "HK", label: "香港" },
    { value: "HU", label: "Magyarország" },
    { value: "IS", label: "Ísland" },
    { value: "IN", label: "भारत" },
    { value: "ID", label: "Indonesia" },
    { value: "IR", label: "ایران" },
    { value: "IQ", label: "العراق" },
    { value: "IE", label: "Éire" },
    { value: "IM", label: "Isle of Man" },
    { value: "IL", label: "ישראל" },
    { value: "IT", label: "Italia" },
    { value: "JM", label: "Jamaica" },
    { value: "JP", label: "日本" },
    { value: "JE", label: "Jersey" },
    { value: "JO", label: "الأردن" },
    { value: "KZ", label: "Қазақcтан" },
    { value: "KE", label: "Kenya" },
    { value: "KI", label: "Kiribati" },
    { value: "KP", label: "조선민주주의인민공화국" },
    { value: "KR", label: "대한민국" },
    { value: "KW", label: "الكويت" },
    { value: "KG", label: "Кыргызстан" },
    { value: "LA", label: "ສາທາລະນະລັດລາວ" },
    { value: "LV", label: "Latvija" },
    { value: "LB", label: "لبنان" },
    { value: "LS", label: "Lesotho" },
    { value: "LR", label: "Liberia" },
    { value: "LY", label: "ليبيا" },
    { value: "LI", label: "Liechtenstein" },
    { value: "LT", label: "Lietuva" },
    { value: "LU", label: "Lëtzebuerg" },
    { value: "MO", label: "澳門" },
    { value: "MG", label: "Madagasikara" },
    { value: "MW", label: "Malawi" },
    { value: "MY", label: "Malaysia" },
    { value: "MV", label: "Maldives" },
    { value: "ML", label: "Mali" },
    { value: "MT", label: "Malta" },
    { value: "MH", label: "Marshall Islands" },
    { value: "MQ", label: "Martinique" },
    { value: "MR", label: "موريتانيا" },
    { value: "MU", label: "Maurice" },
    { value: "YT", label: "Mayotte" },
    { value: "MX", label: "México" },
    { value: "FM", label: "Micronesia (Federated States of)" },
    { value: "MD", label: "Moldova, Republic of" },
    { value: "MC", label: "Monaco" },
    { value: "MN", label: "Монгол Улс" },
    { value: "ME", label: "Crna Gora" },
    { value: "MS", label: "Montserrat" },
    { value: "MA", label: "المغرب" },
    { value: "MZ", label: "Moçambique" },
    { value: "MM", label: "မြန်မာ" },
    { value: "NA", label: "Namibia" },
    { value: "NR", label: "Nauru" },
    { value: "NP", label: "नेपाल" },
    { value: "NL", label: "Nederland" },
    { value: "NC", label: "Nouvelle-Calédonie" },
    { value: "NZ", label: "New Zealand" },
    { value: "NI", label: "Nicaragua" },
    { value: "NE", label: "Niger" },
    { value: "NG", label: "Nigeria" },
    { value: "NU", label: "Niue" },
    { value: "NF", label: "Norfolk Island" },
    { value: "MP", label: "Northern Mariana Islands" },
    { value: "NO", label: "Norge" },
    { value: "OM", label: "عُمان" },
    { value: "PK", label: "پاکستان" },
    { value: "PW", label: "Palau" },
    { value: "PS", label: "فلسطين" },
    { value: "PA", label: "Panamá" },
    { value: "PG", label: "Papua New Guinea" },
    { value: "PY", label: "Paraguay" },
    { value: "PE", label: "Perú" },
    { value: "PH", label: "Pilipinas" },
    { value: "PN", label: "Pitcairn Islands" },
    { value: "PL", label: "Polska" },
    { value: "PT", label: "Portugal" },
    { value: "PR", label: "Puerto Rico" },
    { value: "QA", label: "قطر" },
    { value: "RO", label: "România" },
    { value: "RU", label: "Россия" },
    { value: "RW", label: "Rwanda" },
    { value: "RE", label: "Réunion" },
    { value: "BL", label: "Saint-Barthélemy" },
    { value: "SH", label: "Saint Helena, Ascension and Tristan da Cunha" },
    { value: "KN", label: "Saint Kitts and Nevis" },
    { value: "LC", label: "Saint Lucia" },
    { value: "MF", label: "Saint-Martin (French part)" },
    { value: "PM", label: "Saint Pierre and Miquelon" },
    { value: "VC", label: "Saint Vincent and the Grenadines" },
    { value: "WS", label: "Samoa" },
    { value: "SM", label: "San Marino" },
    { value: "ST", label: "São Tomé and Príncipe" },
    { value: "SA", label: "العربية السعودية" },
    { value: "SN", label: "Sénégal" },
    { value: "RS", label: "Србија" },
    { value: "SC", label: "Seychelles" },
    { value: "SL", label: "Sierra Leone" },
    { value: "SG", label: "Singapore" },
    { value: "SX", label: "Sint Maarten (Dutch part)" },
    { value: "SK", label: "Slovensko" },
    { value: "SI", label: "Slovenija" },
    { value: "SB", label: "Solomon Islands" },
    { value: "SO", label: "Soomaaliya" },
    { value: "ZA", label: "South Africa" },
    { value: "GS", label: "South Georgia and the South Sandwich Islands" },
    { value: "SS", label: "South Sudan" },
    { value: "ES", label: "España" },
    { value: "LK", label: "ශ්‍රී ලංකාව" },
    { value: "SD", label: "السودان" },
    { value: "SR", label: "Suriname" },
    { value: "SJ", label: "Svalbard og Jan Mayen" },
    { value: "SE", label: "Sverige" },
    { value: "CH", label: "Schweiz" },
    { value: "SY", label: "سوريا" },
    { value: "TW", label: "臺灣" },
    { value: "TJ", label: "Тоҷикистон" },
    { value: "TZ", label: "Tanzania, United Republic of" },
    { value: "TH", label: "ประเทศไทย" },
    { value: "TL", label: "Timor-Leste" },
    { value: "TG", label: "Togo" },
    { value: "TK", label: "Tokelau" },
    { value: "TO", label: "Tonga" },
    { value: "TT", label: "Trinidad and Tobago" },
    { value: "TN", label: "تونس" },
    { value: "TR", label: "Türkiye" },
    { value: "TM", label: "Türkmenistan" },
    { value: "TC", label: "Turks and Caicos Islands" },
    { value: "TV", label: "Tuvalu" },
    { value: "UG", label: "Uganda" },
    { value: "UA", label: "Україна" },
    { value: "AE", label: "الإمارات العربية المتحدة" },
    { value: "GB", label: "United Kingdom" },
    { value: "US", label: "United States" },
    { value: "UM", label: "United States Minor Outlying Islands" },
    { value: "UY", label: "Uruguay" },
    { value: "UZ", label: "Oʻzbekiston" },
    { value: "VU", label: "Vanuatu" },
    { value: "VE", label: "Venezuela (Bolivarian Republic of)" },
    { value: "VN", label: "Việt Nam" },
    { value: "VG", label: "British Virgin Islands" },
    { value: "VI", label: "U.S. Virgin Islands" },
    { value: "WF", label: "Wallis and Futuna" },
    { value: "EH", label: "الصحراء الغربية" },
    { value: "YE", label: "اليمن" },
    { value: "ZM", label: "Zambia" },
    { value: "ZW", label: "Zimbabwe" }
];
